import { inject, Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { Role } from '../models/Role';

export const FULL_ACCESS_ROLES = [Role.PS_ADMIN, Role.PRUEFER, Role.DASHBOARD_CONTROLLER];

@Injectable({
  providedIn: 'root',
})
export class AuthorizationService {
  private readonly authenticationService = inject(AuthenticationService);

  getRoles(): Role[] {
    return this.authenticationService
      .getUserRoles()
      ?.map((role) => (this.isRole(role) ? role : null))
      .filter(Boolean) as Role[];
  }

  hasAnyRole(...roles: Role[]): boolean {
    return roles.some((role) => this.hasRole(role));
  }

  hasRole(role: Role): boolean {
    return this.getRoles().includes(role);
  }

  private isRole(value: string): value is Role {
    return Object.values(Role).includes(value as Role);
  }
}
